/**************************************************************************************************************************************************
*   MODULE NAME     :  MetricResultsTab
*   AUTHOR          :  GLSD DEV Team
*   DATE            :  14-04-2021
*   DESCRIPTION     :  Component to load Metrics Results Tab
*   Copyright 2021 Eli Lilly and Company
*   All rights reserved
*
/**************************************************************************************************************************************************
*   *** CHANGE HISTORY ***
/**************************************************************************************************************************************************
*   TRACKING NUMBER: CHG1689267
*   DESCRIPTION: <GLSD>: New System Development
/**************************************************************************************************************************************************/
import React from "react";
import { Container, Row, Col, Button, Popover, OverlayTrigger, ListGroup } from "react-bootstrap";
import { FaSpinner } from "react-icons/fa";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import DataTable from "../common/dataTable/DataTable";
import { loadOtherMetricsPagination } from "../../actions/metricActions";
import * as Helper from "../abstracts/Common/abstractHelper";
import { ddmmmyyyyFormat } from "../common/DateFormat";
import queryString from "query-string";
import { exportPDF } from "../common/ExportToPDF";

class MetricResultsTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      showResults: false,
      paginationData: {
        searchText: "",
        startFrom: 0,
        perPageLimit: 25,
        sortField: "title",
        sortOrder: "asc",
        count: 0,
        page: 1,
        searchCount: 0,
      },
      otherMetrics: [],
      searchCriteriaObject: this.props.searchCriteriaObject,
      metricsCounts: this.props.metricsCounts,
      showResults: this.props.showResults,
      masterData: this.props.masterData
    };
  }

  componentDidMount() {
    this.setState({
      searchCriteriaObject: this.props.searchCriteriaObject,
      metricsCounts: this.props.metricsCounts,
      showResults: this.props.showResults,
      masterData: this.props.masterData
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      searchCriteriaObject: nextProps.searchCriteriaObject,
      metricsCounts: nextProps.metricsCounts,
      showResults: nextProps.showResults,
      masterData: nextProps.masterData
    });
  }
  /**
   * Function to hide/show loader.
   * @param isLoading whether to hide or show loader
   */
  setLoader = (isLoading) => this.setState({ isLoading });

  loadData = ({
    searchText,
    sortField,
    sortOrder,
    filters,
    page,
    sizePerPage,
  }) => {
    const startFrom = (page - 1) * sizePerPage;
    let paginationData = {
      searchText: (searchText === undefined ? '' : searchText),
      startFrom,
      perPageLimit: sizePerPage,
      sortField,
      sortOrder,
      page,
    };
    
    if((searchText != this.state.paginationData.searchText)) {
      paginationData.page = 1;
      paginationData.startFrom = 0;
    }
    
    this.setState({ paginationData }, this.loadOtherMetrics);
  };

  openMetricResultsWindow = () => {
    let { searchCriteriaObject } = this.state;
    Object.keys(searchCriteriaObject).forEach((key) => {
      if (key.toLowerCase().includes("date")) {
        searchCriteriaObject[key] = JSON.stringify(searchCriteriaObject[key]);
      }
    });
    let query = queryString.stringify(searchCriteriaObject);
    window.open(
      `/metricresults?${query}`,
      "",
      `width=${window.innerWidth},height=${window.innerHeight}`
    );
  };

  fromCriteria = () => {
    let { searchCriteriaObject, masterData } = this.state;
    if (!searchCriteriaObject) return "";
    return (
      <ListGroup className="criteriacss" horizontal>
        {Object.keys(searchCriteriaObject)
          .filter((key) => ((searchCriteriaObject[key] || key.includes("include")) && key !== "selectedMetrics"))
          .map(function (key) {
            let val = searchCriteriaObject[key];
            let _key = key;
            try {
              _key = _key.replace(/([-_][a-z])/gi, ($1) => {
                return $1.toUpperCase().replace("-", "").replace("_", "");
              });
              _key = _key.replace(/([A-Z])/g, " $1");
              _key = _key.charAt(0).toUpperCase() + _key.slice(1);

              if (key.includes("include")) {
                val = val === 0 ? "False" : "True";
              } else if (key.toLowerCase().includes("date")) {
                let fromTo = val;
                let val1 = fromTo["from"]
                  ? ` From ( ${ddmmmyyyyFormat(fromTo["from"])} )`
                  : "";
                let val2 = fromTo["to"]
                  ? ` To ( ${ddmmmyyyyFormat(fromTo["to"]
                  )} )`
                  : "";
                val = val1 + val2;
              } else if (
                ["status", "explanation", "product", "country"].some((el) =>
                  key.includes(el)
                )
              ) {
                val = masterData[
                  key.substr(0, key.length - 2) + "List"
                ].filter((e) => val.toString().includes(e.value));
                _key = _key.substr(0, _key.length - 3);
                let str = "";
                val.map((e) => {
                  str = str + e.label + ", ";
                });
                val = str.slice(0, -2);
              } else if (key.includes("caseManager")) {
                switch (key) {
                  case "caseManagerId1":
                    _key = "Abstract Record Screener";
                    break;
                  case "caseManagerId2":
                    _key = "Full Text Screener";
                    break;
                  case "caseManagerId3":
                    _key = "Record Closer";
                    break;
                  default:
                    _key = "Case Manager";
                    break;
                }
                val = masterData["usersList"].filter((e) =>
                  e.value.includes(val)
                );
                val = val[0].label;
              }
            } catch (e) {
              _key = "";
              val = "";
            }
            return (
              <ListGroup.Item key={key} className="py-1 px-1">{`${_key}  :  ${val}`}</ListGroup.Item>
            );
          })}
      </ListGroup>
    );
  };

  loadOtherMetrics = async () => {
    this.setLoader(true);
    try {
      let { paginationData, searchCriteriaObject } = this.state;
      let response = await this.props.loadOtherMetricsPagination({
        pData: paginationData,
        data: searchCriteriaObject,
      });
      if (response && response.data && response.data.result) {
        let data = response.data.result;
        const { count, searchCount } = data;
        paginationData.count = count;
        paginationData.searchCount = searchCount;
        await this.setState({
          otherMetrics: data.list,
          paginationData: paginationData,
        });
      }
    } catch (e) {
      this.setLoader(false);
    }
    this.setLoader(false);
  }; 
  exportFile() {
    const { otherMetrics,searchCriteriaObject } = this.state;
    var widths = [300, 195]
    let criteriaStrPdf = this.generateCriteriaStr()
    let colSelected = ["title", "source"];
    var headers = [["Title", "Source"]];
    if (searchCriteriaObject && searchCriteriaObject.selectedMetrics) {
      if (searchCriteriaObject.selectedMetrics.includes(1)) {
        headers[0].push("Calendar days from initial abstract receipt date to completion of Abstract review ");
        widths.push(72);
        colSelected.push("case1");
      }
      if (searchCriteriaObject.selectedMetrics.includes(2)) {
        headers[0].push("Calendar days from initial abstract receipt to Non-valid article closeout");
        widths.push(72);
        colSelected.push("case2");
      }
      if (searchCriteriaObject.selectedMetrics.includes(3)) {
        headers[0].push("Calendar days from article ordered to receipt of article")
        widths.push(72);
        colSelected.push("case3");
      }
    } else {

    }
    otherMetrics.sort((a, b) => (a.title > b.title) ? 1 : -1)
    const dataDashboard = otherMetrics.map(elt => {
      let element = [];
      colSelected.forEach(ele => {
        let dt = ele.includes("date") && elt[ele] ? ddmmmyyyyFormat(elt[ele]) : (elt[ele] ? elt[ele] : "");

        element.push(dt)
      })
      return element;
    }
    )
    exportPDF("Metrics Results", "", headers, dataDashboard, widths, "Criteria - " + criteriaStrPdf)
  }
  generateCriteriaStr() {
    let { searchCriteriaObject, masterData } = this.state;
    let criteriaStr = ""
    if (!searchCriteriaObject) return ""
    Object.keys(searchCriteriaObject)
      .filter((key) => ((searchCriteriaObject[key] || key.includes("include")) && key !== "selectedMetrics"))
      .map(function (key) {
        let val = searchCriteriaObject[key];
        let _key = key;
        try {
          _key = _key.replace(/([-_][a-z])/gi, ($1) => {
            return $1.toUpperCase().replace("-", "").replace("_", "");
          });
          _key = _key.replace(/([A-Z])/g, " $1");
          _key = _key.charAt(0).toUpperCase() + _key.slice(1);

          if (key.includes("include")) {
            val = val === 0 ? "False" : "True";
          } else if (key.toLowerCase().includes("date")) {
            let fromTo = val;
            let val1 = fromTo["from"]
              ? ` From ( ${ddmmmyyyyFormat(fromTo["from"])} )`
              : "";
            let val2 = fromTo["to"]
              ? ` To ( ${ddmmmyyyyFormat(fromTo["to"]
              )} )`
              : "";
            val = val1 + val2;
          } else if (
            ["status", "explanation", "product", "country"].some((el) =>
              key.includes(el)
            )
          ) {
            val = masterData[
              key.substr(0, key.length - 2) + "List"
            ].filter((e) => val.toString().includes(e.value));
            _key = _key.substr(0, _key.length - 3);
            let str = "";
            val.map((e) => {
              str = str + e.label + ", ";
            });
            val = str.slice(0, -2);
          } else if (key.includes("caseManager")) {
            switch (key) {
              case "caseManagerId1":
                _key = "Abstract Record Screener";
                break;
              case "caseManagerId2":
                _key = "Full Text Screener";
                break;
              case "caseManagerId3":
                _key = "Record Closer";
                break;
              default:
                _key = "Case Manager";
                break;
            }
            val = masterData["userList"].filter((e) =>
              e.value.includes(val)
            );
            val = val[0].label;
          }
        } catch (e) {
          console.log(e);
          _key = "";
          val = "";
        }
        criteriaStr = criteriaStr + `${_key}  :  ${val}` + " ; ";

      });
    return criteriaStr;
  }

  render() {
    let {
      searchCriteriaObject,
      metricsCounts,
      showResults,
      paginationData: { page, searchCount, count },
      otherMetrics,
      isLoading,
    } = this.state;

    let columns = [
      {
        dataField: "abstractId",
        text: "",
        hidden: true,
      },
      {
        dataField: "title",
        text: "Title",
        sort: true,
        formatter: (cellContent, row) => {
          const _popOver = (
            <OverlayTrigger
              placement="right"
              popperConfig={{
                modifiers: {
                  preventOverflow: {
                    enabled: false,
                  },
                },
              }}
              overlay={
                <Popover style={{ maxWidth: "50vw" }} id="popover-contained">
                  <Popover.Content>{row.title}</Popover.Content>
                </Popover>
              }
            >
              <span
                className="fake-link"
                onClick={() => this.openAbstractDetailWindow(row.abstractId)}
              >
                {row.title && row.title.length <= 70
                  ? row.title
                  : row.title && row.title.substr(0, 70) + "..."}
              </span>
            </OverlayTrigger>
          );
          return row && row.title ? _popOver : "";
        },
      },
      {
        dataField: "source",
        text: "Source",
        sort: true,
      },
      {
        dataField: "case1",
        text:
          "Calendar days from initial abstract receipt date to completion of Abstract review ",
        hidden:
          !searchCriteriaObject ||
          !searchCriteriaObject.selectedMetrics ||
          !searchCriteriaObject.selectedMetrics.includes(1),
        headerClasses: "width-150",
        sort: false,
      },
      {
        dataField: "case2",
        text:
          "Calendar days from initial abstract receipt to Non-valid article closeout",
        hidden:
          !searchCriteriaObject ||
          !searchCriteriaObject.selectedMetrics ||
          !searchCriteriaObject.selectedMetrics.includes(2),
        headerClasses: "width-150",
        sort: false,
      },
      {
        dataField: "case3",
        text: "Calendar days from article ordered to receipt of article",
        hidden:
          !searchCriteriaObject ||
          !searchCriteriaObject.selectedMetrics ||
          !searchCriteriaObject.selectedMetrics.includes(3),
        headerClasses: "width-150",
        sort: false,
      },
    ];

    return (
      <>
        {isLoading && (
          <div className="loader">
            <FaSpinner />
          </div>
        )}
        <Row className="mt-3 ml-3">
          <Col sm={11} className="text-center">
            <h3>Aggregate Metrics</h3>
          </Col>
          <Col className="text-right">
            <Button className="addBtn" variant="btn btn-primary" onClick={() => { this.exportFile() }}
>
              Print
            </Button>
          </Col>
        </Row>
        {metricsCounts && metricsCounts.length > 0 ? (
          <>
            <Row>
              <Col sm={{ span: 8, offset: 2 }} className="pl-0 pr-0 pt-2 pb-4">
                <div className="mr-0">
                  <ul className="listWrap">
                    <li className="tableHead">
                      <strong className="title">Metric Name</strong>
                      <strong className="counts">Value</strong>
                    </li>
                    {metricsCounts.map((e) => (
                      <li className="tableBody" key={e.id}>
                        <span className="title">{e.text}</span>
                        <span className="counts">{e.count}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <Row className="mt-1 ml-3">
            <Col sm={11} className="text-center">
              <h6>NA</h6>
            </Col>
          </Row>
        )}
        <Row className="mt-1 mb-2 ml-3">
          <Col sm={11} className="text-center">
            <h3>Other Metrics</h3>
          </Col>
        </Row>
        {showResults ? (
          <>
          <Row className="mb-3 ml-2 mr-2">
          <i style={{color: 'red'}}>Note: Please apply selection criteria to filter the records before navigating to the metrics results screen by clicking Show All Abstracts.</i>
          </Row>
          <Row className="mb-3 ml-2 mr-2">
                      <div className="mb-0 saveTitlecss mt-0">
                        Criteria :
            </div>
                      {this.fromCriteria()}
                    </Row>
            <Row>
              <Col
                sm={{ span: 0, offset: 7 }}
                className="pr-0 text-right filterText pt-1"
              ></Col>
              <Col sm={{ span: 2 }} className="addFilterBoxPos">
                {" "}
              </Col>
              <Col sm={4} className="btns text-right mb-0">
                <Row className="float-right">
                  <div>
                    <Button
                      className="addBtn"
                      variant="btn btn-primary"
                      onClick={this.openMetricResultsWindow}
                    >
                      Show All Abstracts
                    </Button>
                  </div>
                </Row>
              </Col>
            </Row>
            <div className="leftAbstractList ml-3 abstract-datatable">
              <DataTable
                keyField="abstractId"
                defaultSortField="title"
                data={otherMetrics}
                columns={columns}
                csvName={false}
                showSearch={false}
                showPagination={true}
                loadData={this.loadData}
                totalSize={count}
                searchCount={searchCount}
                page={page}
                remote
              />
            </div>
          </>
        ) : (
          <Row>
            <Col className="pt-3 ml-2 abstract-datatable">
              <DataTable
                keyField="abstractId"
                defaultSortField="title"
                data={[]}
                columns={columns}
                csvName={false}
                showSearch={false}
                showPagination={true}
              />
            </Col>
          </Row>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      loadOtherMetricsPagination
    },
    dispatch
  );
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MetricResultsTab)
);
